import { render, staticRenderFns } from "./Invention.vue?vue&type=template&id=796beb59"
import script from "./Invention.vue?vue&type=script&lang=js"
export * from "./Invention.vue?vue&type=script&lang=js"
import style0 from "./Invention.vue?vue&type=style&index=0&id=796beb59&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796beb59')) {
      api.createRecord('796beb59', component.options)
    } else {
      api.reload('796beb59', component.options)
    }
    module.hot.accept("./Invention.vue?vue&type=template&id=796beb59", function () {
      api.rerender('796beb59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InventionApply/Invention.vue"
export default component.exports